import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { SpOrderDto } from '../../order/dtos/sp-order.dto';
import { SpOrderItemInterface } from '../interfaces/sp-order-item.interface';
import { IsNumber, IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { SpBuilderBoardTypeDto } from '../../builder-board-type/dtos/sp-builder-board-type.dto';

@Exclude()
export class SpOrderItemDto
  extends CommonEntityDto
  implements SpOrderItemInterface
{
  @ApiProperty({
    format: 'uuid',
    title: 'Phase ID',
    description: 'The ID of the Phase this material belongs to',
  })
  @IsUUID()
  @Expose()
  spOrderId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Item description ID',
    description: 'The ID based on item description',
    nullable: true,
  })
  @IsUUID()
  @Expose()
  itemDescriptionId!: string | null;

  @ApiProperty({
    title: 'Builder alt item ID',
    nullable: true,
  })
  @Expose()
  builderAltItemId!: string | null;

  @ApiProperty({
    title: 'Item description',
    nullable: true,
  })
  @Expose()
  itemDescription!: string | null;

  @ApiProperty({
    title: 'Quantity ordered',
    nullable: true,
  })
  @Expose()
  @IsNumber()
  quantityOrdered!: number | null;

  @ApiPropertyOptional({
    type: () => SpOrderDto,
    title: 'Sp Order Items',
    description: 'The sp order associated with this sp order',
  })
  @Expose()
  spOrder!: SpOrderDto;

  @ApiPropertyOptional({
    type: () => SpBuilderBoardTypeDto,
    title: 'Sp Builder Board type',
    description: 'The sp builder board type associated with this sp order item',
  })
  @Expose()
  spBuilderBoardType!: SpBuilderBoardTypeDto;
}
